import { getFloorSuggestions } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { HaNContext } from "../shell/HaNContext";

/** The rooms the tab lists on the selected floor, and the available ones it suggests on the floors next to it. */
export const useRoomsModel = () => {
  const { rooms, filterData } = useRequiredContext(HaNContext);

  return {
    status: rooms.status,

    rooms: filterData.rooms.filteredData,

    suggestions: getFloorSuggestions(filterData.rooms.adjacentFilteredData),
  };
};
